import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';

class OrderStatusSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { orderStatuses: [] };
        this.getOrderStatuses = this.getOrderStatuses.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.http = new HttpRequestService();
    }

    componentDidMount() {
        this.getOrderStatuses();
    }

    componentWillUnmount() {

    }

    getOrderStatuses() {
        this.http.get('/api/Orders/GetOrderStatuses', null).then(data=>{
            this.setState({ orderStatuses: data });
        });
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        var options = this.state.orderStatuses.map((item) =>
            <option key={item.key} value={item.key}>{item.value}</option>
        );

        return (
            <select className="form-control" value={this.props.value} onChange={this.handleChange}>
                {this.props.hasAllOption === true &&
                    <option value="-1">-- ALL --</option>
                }
                {options}
            </select>
        );
    }
}
export default OrderStatusSelect